/*
 * House of Daisy — product page behaviour (Product board P1–P7).
 *   - sheets: [data-hod-open="id"] opens <dialog id>, [data-hod-close] shuts it
 *   - alteration quote: ticked alterations become a written WhatsApp message
 *   - speed against her date (ships as is)
 *   - calculator: tier weeks against her wedding date, save on this phone,
 *     and the fourth tier handing over to a person
 * Runs once per page, however many snippets include it.
 */
(function () {
  if (window.hodPdp) return;
  window.hodPdp = true;

  var DAY = 86400000;

  function parseDate(value) {
    // A date input gives YYYY-MM-DD; read it as a local date, not UTC.
    var p = (value || '').split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }

  function today() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function fill(s, vars) {
    return s.replace(/\[(\w+)\]/g, function (_, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function remember(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      return null;
    }
  }

  // The wedding date she gave the cart or the calculator, if any.
  function knownDate() {
    var saved = remember('hod-wedding-date');
    return typeof saved === 'string' ? saved : '';
  }

  /* ---------- Sheets ---------- */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-hod-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-hod-open'));
      if (dialog && dialog.showModal) {
        dialog.showModal();
        dialog._hodOpener = opener;
      }
      return;
    }
    var closer = event.target.closest('[data-hod-close]');
    if (closer) {
      var open = closer.closest('dialog');
      if (open) open.close();
    }
  });

  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (dialog && dialog._hodOpener) dialog._hodOpener.focus();
  }, true);

  function init() {
    // After "Keep an eye out for me" the page returns with the sheet on "Done".
    document.querySelectorAll('[data-hod-notify]').forEach(function (dialog) {
      if (dialog.querySelector('[data-hod-notify-done]') || dialog.querySelector('[role="alert"]')) {
        if (dialog.showModal) dialog.showModal();
      }
    });

    /* ---------- Alteration quote ---------- */
    document.querySelectorAll('[data-hod-quote]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var lines = [form.dataset.intro];
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (box) {
          lines.push('• ' + box.value);
        });
        var extra = form.querySelector('[data-hod-quote-else]');
        if (extra && extra.value.trim()) lines.push(extra.value.trim());
        lines.push(location.origin + location.pathname);
        var base = form.dataset.wa;
        var url = base.indexOf('wa.me') > -1
          ? base + '?text=' + encodeURIComponent(lines.join('\n'))
          : base;
        window.open(url, '_blank', 'noopener');
      });
    });

    /* ---------- Ships as is: speed against her date ---------- */
    document.querySelectorAll('[data-hod-speed]').forEach(function (root) {
      var input = root.querySelector('[data-hod-speed-date]');
      var note = root.querySelector('[data-hod-speed-note]');
      var days = parseInt(root.dataset.days, 10) || 2;
      var t = window.hodPdpStrings || {};
      var now = today();
      input.min = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
      function update() {
        var date = parseDate(input.value);
        if (!date) return;
        remember('hod-wedding-date', input.value);
        var leaves = new Date(today().getTime() + days * DAY);
        var margin = Math.round((date - leaves) / DAY);
        note.textContent = margin >= 0 ? fill(t.speedMargin, { n: margin }) : t.speedTight;
      }
      input.addEventListener('change', update);
      if (knownDate()) {
        input.value = knownDate();
        update();
      }
    });

    /* ---------- Calculator ---------- */
    document.querySelectorAll('[data-hod-calc]').forEach(function (root) {
      var date = root.querySelector('[data-hod-calc-date]');
      var note = root.querySelector('[data-hod-calc-note]');
      var start = root.querySelector('[data-hod-calc-start]');
      var saved = root.querySelector('[data-hod-calc-saved]');
      var key = root.dataset.key;

      function chosen() {
        return root.querySelector('.hod-calc__tiers input:checked');
      }

      function update() {
        var tier = chosen();
        var person = tier && tier.hasAttribute('data-person');
        // The fourth tier is not a gate: it simply hands over to a person.
        root.classList.toggle('hod-calc--person', !!person);
        if (start) start.hidden = !!person;
        var wedding = parseDate(date.value);
        if (!tier || person || !wedding) {
          note.textContent = '';
          return;
        }
        var weeks = parseInt(tier.dataset.weeks, 10) || 8;
        var lands = new Date(today().getTime() + weeks * 7 * DAY);
        var margin = Math.floor((wedding - lands) / (7 * DAY));
        var vars = {
          tier: tier.value,
          date: lands.toLocaleDateString('en-IN', { day: 'numeric', month: 'long' }),
          n: margin
        };
        note.textContent = fill(margin >= 0 ? note.dataset.ok : note.dataset.tight, vars);
      }

      root.addEventListener('change', function (event) {
        if (event.target === date && date.value) remember('hod-wedding-date', date.value);
        update();
      });

      root.querySelector('[data-hod-calc-save]').addEventListener('click', function () {
        var tier = chosen();
        remember(key, { tier: tier ? tier.value : '', date: date.value, at: Date.now() });
        saved.textContent = saved.dataset.saved;
      });

      var before = remember(key);
      if (before && before.tier) {
        root.querySelectorAll('.hod-calc__tiers input').forEach(function (input) {
          if (input.value === before.tier) input.checked = true;
        });
        if (before.date) date.value = before.date;
        saved.textContent = fill(saved.dataset.before, { tier: before.tier });
      } else if (knownDate()) {
        date.value = knownDate();
      }
      update();
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
